import { Link } from "react-router-dom";

export function Form({ children, className = "", ...props }) {
  return (
    <form className={`m-0 p-0 ${className}`} {...props}>
      {children}
    </form>
  );
}

export function Fieldset({ children, className = "", ...props }) {
  return (
    <fieldset className={`m-0 border-none p-0 pb-[30px] ${className}`} {...props}>
      {children}
    </fieldset>
  );
}

export function Title({ children, className = "", ...props }) {
  return (
    <h1
      className={`font-sora text-text-default-light dark:text-text-default-dark text-[30px] font-bold leading-[36px] tracking-[-1.2px] text-center mb-[30px] ${className}`}
      {...props}
    >
      {children}
    </h1>
  );
}

export function LinkButton({ children, className = "", ...props }) {
  return (
    <Link
      {...props}
      className={`relative mb-[10px] flex h-[36px] items-center justify-between rounded-[2px] border border-black bg-white bg-[url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2260%22%20height%3D%2260%22%20viewBox%3D%220%200%2060%2060%22%3E%0A%20%20%3Cpath%20d%3D%22M30%2C17.4959415%20L39.5459415%2C27.0418831%20L37.4246212%2C29.1632034%20L31.5030585%2C23.2419415%20L31.5040585%2C42.4959415%20L28.5040585%2C42.4959415%20L28.5030585%2C23.2359415%20L22.5753788%2C29.1632034%20L20.4540585%2C27.0418831%20L30%2C17.4959415%20Z%22%20fill%3D%22black%22%20transform%3D%22rotate(90%2030%2C30)%22%2F%3E%0A%3C%2Fsvg%3E')] bg-contain bg-right bg-no-repeat pr-[45px] pl-[15px] text-[16px] font-normal text-black hover:no-underline ${className} `}
    >
      {children}
    </Link>
  );
}

export function AccountMessage({ children, className = "" }) {
  return <p className={`text-[14px] ${className}`}>{children}</p>;
}

export function AccountMessageLink({ children, className = "", ...props }) {
  return (
    <Link
      {...props}
      className={`text-primary-blue no-underline hover:underline ${className} `}
    >
      {children}
    </Link>
  );
}
